module.exports = __webpack_public_path__ + "img/phone-plus.de1aeca6.svg";